import { render, staticRenderFns } from "./AudioInputWave.vue?vue&type=template&id=1dbb179d&scoped=true&"
import script from "./AudioInputWave.vue?vue&type=script&lang=js&"
export * from "./AudioInputWave.vue?vue&type=script&lang=js&"
import style0 from "./AudioInputWave.vue?vue&type=style&index=0&id=1dbb179d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dbb179d",
  null
  
)

export default component.exports